import React from "react";

import { CourseWrapper } from "common/entities/courseWrapper/CourseWrapper";
import { Completion } from "common/entities/Subscription";
import { FlexJustify } from "common/fragments/Flex";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import { CardField, CardVariant, CardView } from "common/views/card/Card.view";
import { DropdownSelectVariant } from "common/views/dropdownSelect/DropdownSelect.view";
import { OptionDropdownSelect } from "common/views/dropdownSelect/OptionDropdownSelect";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { isEmpty } from "core/util/ArrayUtils";
import { validateList } from "core/util/ParamUtil";
import StringUtil from "core/util/StringUtil";
import { iDef, iDefL, nDef } from "core/util/TypeUtils";
import { PARAM_USER_ID } from "panels/organizationAdmin/UserList.panel";
import { MetaProvider } from "panels/subscriptions/component/SubscriptionComponent";
import { addEnum } from "typegraph";
import { Config } from "./Config";
import { ISubscriptionParams, Subscription } from "./entities/Subscription";
import labelProvider from "./UserSubscriptions.labels";

const { Labels } = labelProvider;

const SubscriptionsQuery = Query.queryMany<Subscription, ISubscriptionParams>(Subscription);

const PARAM_PAGE_SIZE = "subscriptions.pageSize";
const PARAM_SORT = "subscriptions.sort";
const PARAM_COMPLETIONS = "subscriptions.completions";

const sortOptions = [];

const completionOptions = [];

@Panel({id: "user-subscriptions", configClass: Config, pageParams: true, labelProvider})
class UserSubscriptions extends React.Component<IPanelProps<Config>> {

	public render() {
		const { config, pageParams } = this.props;

		if (nDef(pageParams[PARAM_USER_ID])) {
			return (
				<NonIdealState
					title={<Labels.MissingUser />}
					description={<Labels.MissingUserDescription />}
				/>
			);
		}

		const defaultPageSize = iDef(config.pageSize) ? config.pageSize : 10;
		const pageSize = StringUtil.toInteger(pageParams[PARAM_PAGE_SIZE], defaultPageSize);

		const params: ISubscriptionParams = {
			pageSize,
			sort: validateList([], pageParams[PARAM_SORT], null),
			userIds: [pageParams[PARAM_USER_ID]]
		};

		iDef(pageParams[PARAM_COMPLETIONS], (v: string) => {
			if ("inprogress" === v) {
				params.completions = [addEnum(Completion.NotStarted), addEnum(Completion.Started), addEnum(Completion.Incomplete)];
			}
			if ("completed" === v) {
				params.completions = [addEnum(Completion.Completed), addEnum(Completion.Passed), addEnum(Completion.Failed)];
			}
		});

		return [
			config.enableRefine && (
				<BlockView key="refine" variant={BlockVariant.REFINE} viewKey="refine">
					<FlexJustify>
						<div>
							<OptionDropdownSelect
								options={completionOptions}
								onChange={this.onChangeParam(PARAM_COMPLETIONS)}
								value={pageParams[PARAM_COMPLETIONS]}
								variant={DropdownSelectVariant.MINIMAL}
								viewKey="refine.completions"
							>
								<Labels.CompletionStatus/>
							</OptionDropdownSelect>
						</div>
						<div>
							<OptionDropdownSelect
								options={sortOptions}
								onChange={this.onChangeParam(PARAM_SORT)}
								value={pageParams[PARAM_SORT]}
								variant={DropdownSelectVariant.MINIMAL}
								viewKey="refine.sort"
							>
								<Labels.Sort />
							</OptionDropdownSelect>
						</div>
					</FlexJustify>
				</BlockView>
			),
			(
				<SubscriptionsQuery key="query" params={params}>
					{({data, loading}) => {
						if (loading) {
							return <Loading />;
						}

						if (isEmpty(data)) {
							return (
								<NonIdealState
									title={<Labels.SubscriptionEmpty/>}
									description={<Labels.SubscriptionEmptyDescription />}
								/>
							);
						}

						return (
							<div key="data">
								{data.map(this.renderSubscription)}
								{
									config.enableLoadMore && data.length >= pageSize && (
										<BlockView viewKey="paging">
											<ButtonView
												onClick={() => this.onChangeParam(PARAM_PAGE_SIZE)(pageSize + defaultPageSize)}
												variant={ButtonVariant.PRIMARY}
												viewKey="load-more"
											>
												<Labels.LoadMore />
											</ButtonView>
										</BlockView>
									)
								}
							</div>
						);
					}}
				</SubscriptionsQuery>
			)
		];
	}

	private renderSubscription = (subscription: Subscription) => {
		const { config } = this.props;

		const { subscriptionComponent = {} } = config;

		const w = CourseWrapper.forSubscription(subscription);

		return (
			<CardView key={subscription.id} variant={CardVariant.SURFACE} viewKey="card">
				<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-content">
					<CardField>
						<HeadingView viewKey="title" children={w.getTitle()} />
					</CardField>
					<CardField>
						<MetaProvider fragments={subscriptionComponent.meta} fragmentProps={{config: subscriptionComponent, subscription}} />
					</CardField>
				</BlockView>
			</CardView>
		);
	}

	private onChangeParam = (name: string) => (value: any) => {
		if (iDefL(value)) {
			this.props.actions.pushPageParam(name, value);
		} else {
			this.props.actions.removePageParam(name);
		}
	}
}



// WEBPACK FOOTER //
// ./src/panels/userSubscriptions/UserSubscriptions.panel.tsx